export function useSite() {
  const siteName = useState('siteName', () => 'Suite')

  return {
    siteName,
  }
}
